import React, { FunctionComponent } from 'react';
import styles from './process-boxes.module.scss';
import { IProcessBoxProps, ProcessBox } from './process-box/process-box';

export interface IProcessBoxesProps {
  boxes: IProcessBoxProps[];
}

export const ProcessBoxes: FunctionComponent<IProcessBoxesProps> = ({
  boxes
}) => (
  <div className={styles.wrapper}>
    {boxes &&
      boxes.map((box: IProcessBoxProps, i: number) => (
        <div className={styles.boxWrapper} key={i}>
          <ProcessBox {...box} number={i + 1} />
        </div>
      ))}
  </div>
);
